import React from 'react'
import styled from '@emotion/styled'

import GeneralModal from './GeneralModal'
import BasicButton from '../button'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`
const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    width: 40%;
  }
`
const ConfirmationModal = ({ modalName, title = '', confirmText = 'Confirm', cancelText = 'Cancel', onConfirmSelected, onCancelSelected, children, testId, ...props }) => {
  return (
    <GeneralModal name={modalName} title={title} maxWidth={300} minHeight={240} testId={testId} {...props}>
      <ModalContent>
        {children}
        <ButtonGroup>
          <BasicButton
            data-testid = {`${testId}-btn-delete-cancel`}
            secondary
            onClick={() => {
              if (typeof onCancelSelected === 'function') onCancelSelected()
            }}>
            {cancelText}
          </BasicButton>
          <BasicButton
            data-testid = {`${testId}-btn-delete-ok`}
            onClick={() => {
              if (typeof onConfirmSelected === 'function') onConfirmSelected()
            }}>
            {confirmText}
          </BasicButton>
        </ButtonGroup>
      </ModalContent>
    </GeneralModal>
  )
}

export default ConfirmationModal
